// extracted by mini-css-extract-plugin
module.exports =  {"icon":"WBj0bRIm0daUmtR6yzXG","root":"scsuSYNrb9_osTyn5tZF"};